













































import {
	computed,
	defineComponent,
	watch,
} from '@vue/composition-api';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import LoaderState from '@front-app/components/LoaderState.vue';
import { Routes } from '@front-app/constants/routes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useCommunitiesStore } from '@front-app/store/piniaModules/communities';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { useTabbedNav } from '@front-app/components/tabs/useTabbedNav';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import BackButton from '@front-app/components/buttons/BackButton.vue';

enum CommunityTabs {
	EDIT_COMMUNITY = 'edit-community',
	CONTENT = 'content',
	SETTINGS = 'settings',
}

const ROUTE_TO_TAB: {[key: string]: string} = {
	[Routes.MANAGE_COMMUNITY_EDIT_COMMUNITY]: CommunityTabs.EDIT_COMMUNITY,
	[Routes.MANAGE_COMMUNITY_CONTENTS]: CommunityTabs.CONTENT,
	[Routes.MANAGE_COMMUNITY_SETTINGS]: CommunityTabs.SETTINGS,
};

const TAB_BUTTONS: ButtonNavButton[] = [
	{
		key: CommunityTabs.EDIT_COMMUNITY,
		id: CommunityTabs.EDIT_COMMUNITY,
		label: 'community.edit.manage-community',
		to: { name: Routes.MANAGE_COMMUNITY_EDIT_COMMUNITY },
	},
	{
		key: CommunityTabs.CONTENT,
		id: CommunityTabs.CONTENT,
		label: 'groups.groups',
		to: { name: Routes.MANAGE_COMMUNITY_CONTENTS },
	},
	{
		key: CommunityTabs.SETTINGS,
		id: CommunityTabs.SETTINGS,
		label: 'community.edit.branding',
		to: { name: Routes.MANAGE_COMMUNITY_SETTINGS },
	},
];

export default defineComponent({
	components: {
		LoaderState,
		ErrorCard,
		TabbedNav,
		ColumnContainer,
		ScrollingColumn,
		PaddedContent,
		BackButton,
	},
	props: {
		communityId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const communitiesStore = useCommunitiesStore();
		const community = computed(() => communitiesStore.getById(props.communityId));

		const { track, isLoading, isError } = useAsyncStatus();
		watch(() => props.communityId, async (newVal, prevVal) => {
			if (newVal !== prevVal) {
				await track(communitiesStore.fetchById(props.communityId));
			}
		}, { immediate: true });

		// Tabs
		const {
			tabButtons,
			currentTabKey,
		} = useTabbedNav(ctx, TAB_BUTTONS, ROUTE_TO_TAB);
		// END Tabs

		const toCommunityManagement = {
			name: Routes.COMMUNITY_MANAGEMENT,
		};

		return {
			isLoading,
			isError,
			community,
			// Tabs
			toCommunityManagement,
			tabButtons,
			currentTabKey,
		};
	},
});
